<template>
  <div>
    <v-dialog
      max-width="550px"
      v-model="show"
      scrollable
    >
      <v-card>
        <v-card-title>
          Templates list
          <v-spacer></v-spacer>
          <v-text-field
            dense
            hide-details
            v-model="search"
            append-icon="mdi-magnify"
            label="Search template"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click.prevent="show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3">
          <v-data-table
            dense
            :headers="templates_headers"
            :items="templates"
            :items-per-page="-1"
            :search="search"
            hide-default-footer
          >
            <template v-slot:[`item.Actions`]="{ item }">
              <v-btn icon small
                @click.prevent="getTemplateDetailsById(item.ID)"
                color="success"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon small
                color="red darken-2"
                @click.prevent="showDeleteTemplateDialog(item.ID)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>

          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteTemplateDialog"
      max-width="300"
    >
      <v-card>
        <v-card-title>Remove Template</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3">
          Are you sure?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn small color="primary" @click="hideDeleteTemplateDialog">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn small color="red darken-4 white--text" @click="deleteTemplate">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

export default {
  name: 'EmailsManager',
  props: {
    value: {
      required: false
    }
  },
  data () {
    return {
      selectedTemplate: null,
      showTemplate: false,
      search: '',
      showDialog: false,
      addMode: false,
      deleteTemplateDialog: false,
      templateIDToRemove: null,
      templates_headers: [
        {
          text: 'ID',
          value: 'ID',
          divider: true,
          width: '10%',
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Name',
          value: 'Name',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Type',
          value: 'Type_Descr',
          divider: true,
          width: '20%',
          class: 'px-2 text-no-wrap'
        },
        {
          text: '',
          value: 'Actions',
          cellClass: 'px-2 text-no-wrap',
          class: 'px-2 text-no-wrap',
          width: '5%',
          sortable: false
        }
      ]
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    user () {
      return this.$store.getters.getUser
    },
    templates () {
      return this.$store.getters.getEmailTemplates
    }
  },
  mounted () {
    this.getAllTemplates()
  },
  methods: {
    getAllTemplates () {
      this.axios.get('/api/templates', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setEmailTemplatesList', { emailTemplatesList: res.data })
      }).catch(error => {
        this.$store.dispatch('setError', {
          errorMsg: error.message + ' - ' + error.response.data
        })
      })
    },
    getTemplateDetailsById (id) {
      this.axios.get(`/api/template/${id}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.selectedTemplate = res.data[0]
        this.$emit('showEmailsEditor', this.selectedTemplate)
      }).catch(error => {
        this.$store.dispatch('setError', {
          errorMsg: error.message + ' - ' + error.response.data
        })
      })
    },
    addNewTemplate () {
      this.selectedTemplate = null
      this.showTemplate = true
    },
    showDeleteTemplateDialog (templateID) {
      this.deleteTemplateDialog = true
      this.templateIDToRemove = templateID
    },
    hideDeleteTemplateDialog () {
      this.deleteTemplateDialog = false
      this.templateIDToRemove = null
    },
    deleteTemplate () {
      this.axios.post('/api/deleteTemplate', { templateID: this.templateIDToRemove }, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(() => {
        this.$store.dispatch('removeEmailTemplate', { templateID: this.templateIDToRemove })
        this.$store.dispatch('setSuccess', { successMsg: 'Successfully deleted' })
        this.templateIDToRemove = null
        this.deleteTemplateDialog = false
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error })
      })
    }
  }
}
</script>
